$(document).ready(function() {
    // Function to apply styles based on the existing color inputs
    function applyLabelStyles() {
        $('input[name="Color"]').each(function() {
            var colorValue = $(this).val();
            var label = $('label[for="' + this.id + '"]');
            
            // Apply the color class based on the input value
            if (colorValue === 'Black') {
                label.addClass('black');
            } else if (colorValue === 'Pink') {
                label.addClass('pink');
            } else if (colorValue === 'Blue') {
                label.addClass('blue');
            }
        });
    }

    // Call the function on page load
    applyLabelStyles();
});

document.querySelector('.custom_engraving_wrap form').addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent the default form submission

    var engravingInput = document.querySelector('7418690896052').value; // Get the engraving input value
    var productId = document.querySelector('7418690896052').getAttribute('#product-form-template--17349391089844__main-product'); // Get the product ID

    // AJAX request to add product to cart
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items: [{
                id: productId,
                quantity: 1,
                properties: {
                    'Engraving': engravingInput // Add engraving as a property
                }
            }]
        })
    })
    .then(response => {
        if (response.ok) {
            return response.json();
        }
        throw new Error('Network response was not ok.');
    })
    .then(data => {
        console.log('Product added:', data);
        // Optionally update the cart UI here
    })
    .catch(error => {
        console.error('There has been a problem with your fetch operation:', error);
    });
});


function updateButtonState() {
    var flkty = $carousel.data('flickity');

    if (flkty) {
        var selectedIndex = flkty.selectedIndex;
        var lastIndex = flkty.slides.length - 1;

        console.log('Selected Index:', selectedIndex);
        console.log('Last Index:', lastIndex);

        // Disable the Prev button if at the first slide or if there's only one slide
        if (selectedIndex === 0 || flkty.slides.length <= 1) {
            $prevButton.addClass('disabled');
            console.log('Prev Button Disabled');
        } else {
            $prevButton.removeClass('disabled');
        }

        // Disable the Next button if at the last slide or if there's only one slide
        if (selectedIndex === lastIndex || flkty.slides.length <= 1) {
            $nextButton.addClass('disabled');
            console.log('Next Button Disabled');
        } else {
            $nextButton.removeClass('disabled');
        }
    } else {
        console.log('Flickity instance not found');
    }
}
$(document).ready(function() {
    console.log('Script is running');

    var $carousel = $('.flickity-enabled');
    
    if ($carousel.length) {
        console.log('Carousel found');
        $carousel.flickity(); // Initialize Flickity
    } else {
        console.log('Carousel not found');
    }

    var $prevButton = $('.flickity-prev');
    var $nextButton = $('.flickity-next');

    console.log('Prev button:', $prevButton.length);
    console.log('Next button:', $nextButton.length);

    function updateButtonState() {
        var flkty = $carousel.data('flickity');

        if (flkty) {
            var selectedIndex = flkty.selectedIndex;
            var lastIndex = flkty.slides.length - 1;

            console.log('Selected Index:', selectedIndex);
            console.log('Last Index:', lastIndex);

            // Disable the Prev button if at the first slide or if there's only one slide
            if (selectedIndex === 0 || flkty.slides.length <= 1) {
                $prevButton.addClass('disabled');
                console.log('Prev Button Disabled');
            } else {
                $prevButton.removeClass('disabled');
            }

            // Disable the Next button if at the last slide or if there's only one slide
            if (selectedIndex === lastIndex || flkty.slides.length <= 1) {
                $nextButton.addClass('disabled');
                console.log('Next Button Disabled');
            } else {
                $nextButton.removeClass('disabled');
            }
        } else {
            console.log('Flickity instance not found');
        }
    }

    updateButtonState();

    $carousel.on('select.flickity', function() {
        updateButtonState();
    });

    $(window).on('load', function() {
        updateButtonState();
    });
});



jQuery(document).ready(function() {
  jQuery(".top-navigation .mobile-button").on("click", function() {
    jQuery(".mobile-toggle-wrapper").removeClass("active");
  });
});












